import { useEffect } from "react";
import { LIFECYCLE, STATUS } from "react-joyride";
import { TOUR_ANCHOR_RECOVERY_MS } from "../constants/tour";

const hasAnchor = (target) =>
   Boolean(typeof target === "string" ? document.querySelector(target) : target?.isConnected);

// The library checks for a missing anchor only when the lifecycle changes, so one
// that is unmounted while its stop is already on screen goes unnoticed: the
// tooltip stops rendering but the overlay stays, leaving the page dimmed with no
// Exit tour to click and no way out. It happens whenever an action a stop invites
// swaps the anchor out, the studio preview button being the clearest case. Moving
// on is the same recovery the library applies to an anchor missing at step entry.
const useTourAnchorRecovery = ({ step, state, controls }) => {
   const target = step?.target ?? null;
   const isStopOnScreen = state.status === STATUS.RUNNING && state.lifecycle === LIFECYCLE.TOOLTIP;

   useEffect(() => {
      if (!isStopOnScreen || !target) {
         return undefined;
      }

      const timerId = setInterval(() => {
         if (!hasAnchor(target)) {
            controls.next();
         }
      }, TOUR_ANCHOR_RECOVERY_MS);

      return () => clearInterval(timerId);
   }, [isStopOnScreen, target, controls]);
};

export default useTourAnchorRecovery;
